<script type="text/javascript">
	import BaseModal from "./modal.svelte";
	import Icon from "../icon.svelte";
	import Loader from "../loader.svelte";
	import Bordered from "../borderedInput.svelte";
	let opened = true;


	let apiResponse, loading = false;
	let payPrice = 15, qiwi = "";

	let close;

	$: if(!opened && $$props.onClose) $$props.onClose(); 

	function apiRequest(){
		loading = true;
		window.api.withdraw(qiwi, payPrice, r=>{
			loading = false;
			apiResponse = r;
			if (r.status=="success"){
				close();
			}
		})
	}
</script>

{#if opened}
<BaseModal bind:opened bind:close>
	<span slot="heading">
		Вывод средств
	</span>

	{#if apiResponse && apiResponse.status == "error"}
	<div class="message">
		<span>{apiResponse.message}</span>
	</div>
	{/if}

	<form action="#" on:submit|preventDefault={apiRequest}>
		<div class="form-group">
			<label for="qiwi">QIWI кошелек:</label>
		
			<input id="qiwi" type="text" class="app_input-default"
			bind:value={qiwi}>
	
		</div>
		<div class="form-group">
		<label for="pay">Сумма вывода:</label>
		<Bordered>
			<input id="pay" type="number" min="10" step="1" class="app_input-transparent"
			bind:value={payPrice}> <i>&#x20bd;</i>
		</Bordered>
		</div>
		<button class="app_button-primary" style="width:100%">
			{#if loading}<Loader/>{:else}Вывести ({payPrice} &#x20bd){/if}</button>
	</form>
</BaseModal>
{/if}

<style type="text/css">
	form > label{
		margin-bottom: 14px;
    display: block;
    margin-top: 16px;
	}
	form > button{
		margin-top: 15px;
	}
</style>